module.exports = __webpack_public_path__ + "img/Best of Süsswein.1b1edfb9.jpg";